import { observer } from 'mobx-react';
import React, { Component } from 'react';
import TubesViewModel from 'stores/models/TestTubeRack';
import { Colors } from 'utils/Visualization';
import TestTube from './TestTube';

interface IProps {
  model?: TubesViewModel | null;
}

class View extends Component<IProps> {
  render() {
    const { model } = this.props;
    const colorIPTGz = model?.hasIPTGz ? Colors.Yellow : Colors.Water;
    const colorIPTGa = model?.hasIPTGa ? Colors.Orange : Colors.Water;
    const colorONPGz = model?.hasONPGz ? Colors.Yellow : Colors.Water;
    const colorONPGa = model?.hasONPGa ? Colors.Orange : Colors.Water;

    return (
      <div className='is-flex is-justify-content-space-between'>
        <div className='is-flex-centered is-flex-direction-column'>
          <div className='is-flex mb-2'>
            <TestTube color={colorONPGz} label='-' />
            <TestTube color={colorIPTGz} label='+' />
          </div>
          <div className='has-text-centered is-size-7'>
            <div className='is-family-code'>lacZ</div>
            <div>ONPG</div>
          </div>
        </div>
        <div className='is-size-7 mt-1'>IPTG</div>
        <div className='is-flex-centered is-flex-direction-column'>
          <div className='is-flex mb-2'>
            <TestTube color={colorONPGa} label='-' />
            <TestTube color={colorIPTGa} label='+' />
          </div>
          <div className='has-text-centered is-size-7'>
            <div className='is-family-code'>lacA</div>
            <div>Acetyl</div>
          </div>
        </div>
      </div>
    );
  }
}

const TestTubeRack = observer(View);
export default TestTubeRack;
